import React from "react";
import { Header } from "./QueryBuilder";
import { CirclePlus, Delete } from "lucide-react";

type Props = {
  headers: Header[];
  handleHeaderChange: (
    index: number,
    field: "key" | "value",
    value: string,
  ) => void;
  removeHeader: (index: number) => void;
  addHeader: () => void;
};

const QueryBuilderHeader: React.FC<Props> = ({
  headers,
  handleHeaderChange,
  removeHeader,
  addHeader,
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mt-3 ">
        <p className="font-bold text-md ml-1 text-primaryBlue">Headers</p>
        <p
          onClick={addHeader}
          className="text-primaryBlue flex items-center gap-1 cursor-pointer mr-1"
        >
          <CirclePlus size={14} /> Add Header
        </p>
      </div>
      {headers.map((header, idx) => (
        <React.Fragment key={idx}>
          <div
            key={idx}
            className="flex space-x-2 items-center mt-1 bg-muted p-2 rounded-md"
          >
            <input
              placeholder="Content-Type"
              name={`key-${idx}`}
              value={header.key}
              onChange={(e) => handleHeaderChange(idx, "key", e.target.value)}
              className="border p-2 rounded-md w-1/3 bg-background"
            />
            <input
              placeholder="application/json"
              name={`value-${idx}`}
              value={header.value}
              onChange={(e) => handleHeaderChange(idx, "value", e.target.value)}
              className="border p-2 rounded-md w-2/3 bg-background"
            />
            <button
              onClick={() => removeHeader(idx)}
              className="text-primary hover:text-primary"
            >
              <Delete size={16} />
            </button>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default QueryBuilderHeader;
